export default {
  state: {
    info: {}
  },
  mutations: {
    'GET_COMPANYINFO' (state, info) {
      state.info = info
      // GrowingIO
      window._vds.push(['setCS6', 'companyName', info.companyName])
      window._vds.push(['setCS7', 'abbreviation', info.abbreviation])
      window._vds.push(['setCS8', 'majorBusiness', ['','人工智能','智能硬件','机器人','教育','医疗','公共服务','其他'][+info.majorBusiness]])
      window._vds.push(['setCS9', 'contactName', info.contactName])
      window._vds.push(['setCS10', 'contactMobile', info.contactMobile])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js